import { jsonClass } from '@sumbricht/json-class-serializer'

@jsonClass('LicenseLimitationList')
export class LicenseLimitationList {
	constructor(public allowed: string[] | '*') {}

	get isRestricted() {
		return this.allowed != '*'
	}

	toString() {
		if (this.allowed == '*') return this.allowed
		if (!this.allowed.length) return '(none)'
		return this.allowed.join(', ')
	}
}
